import { render, staticRenderFns } from "./ReviewTypeDialog.vue?vue&type=template&id=d13f1ba6&scoped=true&"
import script from "./ReviewTypeDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewTypeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTypeDialog.vue?vue&type=style&index=0&id=d13f1ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13f1ba6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItem,VItemGroup})
